import React from 'react';
import PropTypes from 'prop-types';

const Select = ({
  options,
  id,
  name,
  value,
  setValue,
  className,
  placeholder,
  textLabel,
  property,
  required,
  children,
}) => (
  <>
    {textLabel && <label label={id} htmlFor={id}>{textLabel}</label>}

    <div className={className}>
      <select
        className={className}
        name={name}
        id={id}
        value={value}
        required={required}
        onChange={(e) => setValue(e.target.value)}
      >
        {children
          ? (
            <>
              <option className={className} value="" defaultValue disabled>
                {placeholder || 'Cargando...'}
              </option>
              {children}
            </>
          )
          : (
            <>
              <option className={className} value="" defaultValue disabled>
                {placeholder || 'Cargando...'}
              </option>
              {options?.length > 0
                && (options.map((option) => (
                  <option
                    className={className}
                    key={Math.random()}
                    value={property ? option[property] : option}
                  >
                    {property ? option[property] : option}
                  </option>
                )))}
            </>
          )}

      </select>
    </div>
  </>
);

Select.propTypes = {
  options: PropTypes.oneOfType([
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
    }),
    PropTypes.string,
    PropTypes.array,
  ]),
  id: PropTypes.string,
  name: PropTypes.string,
  setValue: PropTypes.func,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  textLabel: PropTypes.string,
  property: PropTypes.string,
  required: PropTypes.bool,
  children: PropTypes.node,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
};

Select.defaultProps = {
  options: [],
  id: 'standard-select',
  name: '',
  setValue: () => {},
  className: 'select',
  placeholder: '',
  textLabel: '',
  property: '',
  required: false,
  children: null,
};

export default Select;
